import React, {useState, useEffect, useContext} from "react";
import ExpandBox from '../common/ExpandBox';
import axios from "../common/axios";
import {BrandContext} from "../common/BrandContext"
import useCurrentConcept from "../hooks/useCurrentConcept";
import {TemplateContext} from "../common/TemplateContext";
import CircularLoader from "../common/CircularLoader";

const UserReviewFeedback = props => {
    const {testResultId, title, handleClose} = props;
    const brandConfig = useContext(BrandContext);
    const {singlePage} = useContext(TemplateContext);
    const {loadCurrentConcept} = useCurrentConcept();
    const [isLoading, setLoading] = useState(true);
    const [reviewConcepts, setReviewConcepts] = useState([]);

    const handleSelectConcept = (conceptId) => {
        if (conceptId) {
            if (singlePage) {
                loadCurrentConcept(conceptId);
            } else {
                window.location.href = '/controlCentre/navigateSyllabuses.action?conceptId=' + enabledConcept.conceptId;
            }
        }
    }

    useEffect(() => {
        setLoading(true);
        axios.get('/web/ui/test/findUserDiagnosticReviewConcepts', {params: {testResultId: testResultId}})
            .then(response => {
                setReviewConcepts(response.data);
                setLoading(false);
            });
    }, []);

    if(isLoading) {
        return (
            <CircularLoader pageCentered={false}/>
        )
    }

    return (
        <>
            {reviewConcepts.length == 0 && (
                <div className={"errorMessage"}>There are no review {brandConfig.conceptsName.toLowerCase()} for this test.</div>
            )}
            {reviewConcepts.length > 0 && (
                <ul>
                    {reviewConcepts.map((reviewConcept, index) => (
                        <li key={index}>
                            <a onClick={() => {handleSelectConcept(reviewConcept.conceptId)}}>{reviewConcept.conceptName}</a>
                            &nbsp;-&nbsp;
                            {reviewConcept.questionSequences.map((seq, questionIndex) => (
                                <span key={questionIndex}>Q{seq + 1}</span>
                            )).reduce((prev, curr) => [prev, ', ', curr])}
                        </li>))
                    }
                </ul>
            )}
        </>
    )
}

export default UserReviewFeedback;